export const Caesar = (color) => {
  return `
       <svg xmlns="http://www.w3.org/2000/svg" width="400" height="180" viewBox="0 0 400 180" fill="none">
          <g filter="url(#filter0_i_71_127)">
          <path d="M0 0H135.008V46.8208H0V0Z" fill="${color}"/>
          </g>
          <g filter="url(#filter1_i_71_127)">
          <path d="M132.496 0H267.504V46.8208H132.496V0Z" fill="${color}"/>
          </g>
          <g filter="url(#filter2_i_71_127)">
          <path d="M264.992 0H400V46.8208H264.992V0Z" fill="${color}"/>
          </g>
          <g filter="url(#filter3_i_71_127)">
          <path d="M0 43.6995H135.008V90.5203H0V43.6995Z" fill="${color}"/>
          </g>
          <g filter="url(#filter4_i_71_127)">
          <path d="M132.496 43.6995H267.504V90.5203H132.496V43.6995Z" fill="${color}"/>
          </g>
          <g filter="url(#filter5_i_71_127)">
          <path d="M264.992 43.6995H400V90.5203H264.992V43.6995Z" fill="${color}"/>
          </g>
          <g filter="url(#filter6_i_71_127)">
          <path d="M0 88.4393H135.008V135.26H0V88.4393Z" fill="${color}"/>
          </g>
          <g filter="url(#filter7_i_71_127)">
          <path d="M132.496 88.4393H267.504V135.26H132.496V88.4393Z" fill="${color}"/>
          </g>
          <g filter="url(#filter8_i_71_127)">
          <path d="M264.992 88.4393H400V135.26H264.992V88.4393Z" fill="${color}"/>
          </g>
          <g filter="url(#filter9_i_71_127)">
          <path d="M0 133.179H135.008V180H0V133.179Z" fill="${color}"/>
          </g>
          <g filter="url(#filter10_i_71_127)">
          <path d="M132.496 133.179H267.504V180H132.496V133.179Z" fill="${color}"/>
          </g>
          <g filter="url(#filter11_i_71_127)">
          <path d="M264.992 133.179H400V180H264.992V133.179Z" fill="${color}"/>
          </g>
          <defs>
          <filter id="filter0_i_71_127" x="-2" y="-2" width="137.008" height="48.8208" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix"/>
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
          <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect1_innerShadow_71_127"/>
          <feOffset dx="-4" dy="-4"/>
          <feGaussianBlur stdDeviation="2"/>
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow_71_127"/>
          </filter>
          <filter id="filter1_i_71_127" x="130.496" y="-2" width="137.008" height="48.8208" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix"/>
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
          <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect1_innerShadow_71_127"/>
          <feOffset dx="-4" dy="-4"/>
          <feGaussianBlur stdDeviation="2"/>
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow_71_127"/>
          </filter>
          <filter id="filter2_i_71_127" x="262.992" y="-2" width="137.008" height="48.8208" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix"/>
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
          <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect1_innerShadow_71_127"/>
          <feOffset dx="-4" dy="-4"/>
          <feGaussianBlur stdDeviation="2"/>
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow_71_127"/>
          </filter>
          <filter id="filter3_i_71_127" x="-2" y="41.6995" width="137.008" height="48.8208" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix"/>
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
          <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect1_innerShadow_71_127"/>
          <feOffset dx="-4" dy="-4"/>
          <feGaussianBlur stdDeviation="2"/>
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow_71_127"/>
          </filter>
          <filter id="filter4_i_71_127" x="130.496" y="41.6995" width="137.008" height="48.8208" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix"/>
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
          <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect1_innerShadow_71_127"/>
          <feOffset dx="-4" dy="-4"/>
          <feGaussianBlur stdDeviation="2"/>
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow_71_127"/>
          </filter>
          <filter id="filter5_i_71_127" x="262.992" y="41.6995" width="137.008" height="48.8208" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix"/>
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
          <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect1_innerShadow_71_127"/>
          <feOffset dx="-4" dy="-4"/>
          <feGaussianBlur stdDeviation="2"/>
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow_71_127"/>
          </filter>
          <filter id="filter6_i_71_127" x="-2" y="86.4393" width="137.008" height="48.8208" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix"/>
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
          <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect1_innerShadow_71_127"/>
          <feOffset dx="-4" dy="-4"/>
          <feGaussianBlur stdDeviation="2"/>
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow_71_127"/>
          </filter>
          <filter id="filter7_i_71_127" x="130.496" y="86.4393" width="137.008" height="48.8208" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix"/>
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
          <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect1_innerShadow_71_127"/>
          <feOffset dx="-4" dy="-4"/>
          <feGaussianBlur stdDeviation="2"/>
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow_71_127"/>
          </filter>
          <filter id="filter8_i_71_127" x="262.992" y="86.4393" width="137.008" height="48.8208" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix"/>
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
          <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect1_innerShadow_71_127"/>
          <feOffset dx="-4" dy="-4"/>
          <feGaussianBlur stdDeviation="2"/>
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow_71_127"/>
          </filter>
          <filter id="filter9_i_71_127" x="-2" y="131.179" width="137.008" height="48.8208" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix"/>
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
          <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect1_innerShadow_71_127"/>
          <feOffset dx="-4" dy="-4"/>
          <feGaussianBlur stdDeviation="2"/>
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow_71_127"/>
          </filter>
          <filter id="filter10_i_71_127" x="130.496" y="131.179" width="137.008" height="48.8208" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix"/>
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
          <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect1_innerShadow_71_127"/>
          <feOffset dx="-4" dy="-4"/>
          <feGaussianBlur stdDeviation="2"/>
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow_71_127"/>
          </filter>
          <filter id="filter11_i_71_127" x="262.992" y="131.179" width="137.008" height="48.8208" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix"/>
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
          <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="effect1_innerShadow_71_127"/>
          <feOffset dx="-4" dy="-4"/>
          <feGaussianBlur stdDeviation="2"/>
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow_71_127"/>
          </filter>
          </defs>
          </svg>
        `;
};
